import { getFeature } from 'Cloud/Application/FeaturesEs6';

/**
 * @see https://jira.vk.team/browse/CLOUDWEB-18730 Раздел "Документы" на b2b для бесплатников
 */
export const UNPAID_B2B_DISABLE_ALLDOCUMENTS = getFeature('unpaid-b2b-disable-alldocuments') || false;

export const B2B_ALLDOCUMENTS_REQUEST_BUTTON = getFeature('b2b-alldocuments-request-button') || false;

export const B2B_ALLDOCUMENTS_REQUEST_INTERVAL = getFeature('b2b-alldocuments-request-interval') ?? 3 * 24 * 60 * 60 * 1000;
